export default __webpack_public_path__ + "static/media/35.88c51b91.png";